/**
 * timeShowFormatModule 时间展示格式处理
 * Author Qian.qianchen 2019-07-04
 */
"use strict";
angular.module("timeShowFormatModule", []).
directive("timeShowFormat", ["$filter", function($filter) {
    return {
        restrict: "A",
        repalace: false,
        scope: {
            time: "="
        },
        link: function($scope, $elem, $attrs) {
            $scope.$watch('time', (newVal) => {
                if (angular.isDefined($scope.time)) {
                    init();
                }
            });
            /**
             * [init description] 初始化
             * @return {[type]} [description]
             */
            function init() {
                $scope.timeStr = $filter("date")($scope.time, "yyyy-MM-dd hh:mm:ss");
                $scope.timeArr = $scope.timeStr.split(' ');
                $elem.html(`<span class="date_value">${$scope.timeArr[0]}</span><br/><span class="time_vaue">${$scope.timeArr[1]}</span>`);
            }
        }
    };
}]);